import { Store } from 'vuex';
import { GlobalWorkspace, GlobalWorkspaceStoreModule } from './index';
import { GlobalWorkspaceOptions, defaults } from './options';

export default
class GlobalWorkspaceService implements GlobalWorkspace {

	protected store!: Store<unknown>;

	public options: GlobalWorkspaceOptions = {...defaults, ...{store: this.store}};

	boot(options: GlobalWorkspaceOptions) {

		if (! options.store) throw "Global Workspace requires Vuex Store";
		else this.store = options.store;

		this.options = {...defaults, ...options};

		this.registerModule();
	}

	registerModule() {
		this.store.registerModule(this.options.moduleNamespace, GlobalWorkspaceStoreModule);
	}

	get home(): string {
		return this.options.globalHomeName;
	}

	get isGlobal(): boolean {
		return this.store.getters[`${this.options.moduleNamespace}/isGlobal`];
	}

	setToGlobal(): void {
		this.store.dispatch(`${this.options.moduleNamespace}/setToGlobal`);
	}

	setToNonGlobal(): void {
		this.store.dispatch(`${this.options.moduleNamespace}/setToNonGlobal`);
	}
}